import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import axiosRequest from "../../services/axios/axiosRequest";
import Loading from "../../components/loading/Loading";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import PageTitle from "../../components/pageTitle/PageTitle";
import { Alert } from "react-bootstrap";
import styles from './searchResults.module.css';
import { Helmet } from "react-helmet-async";


export default function SearchResults() {
  const navigateTo = useNavigate();
  const [searchParams] = useSearchParams();
  const query = searchParams.get("query");
  const [results, setResults] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (query) {
      axiosRequest
        .get(`/search/?search=${query}`, { signal: AbortSignal.timeout(10000) })
        .then((res) => setResults(res.data))
        .catch((err) => console.error(err))
        .finally(() => setIsLoading(false));
    } else {
      navigateTo('/notFound');
    }
  }, [query]);

  return (
    <>
      <Helmet>
        {isLoading ?
          <>
            <title>نتیجه جستجو - نوآوران پژوه</title>
            <meta name="description" content="نتیجه جستجوی محصولات در وبسایت شرکت نوآوران پژوه" />
          </>
          :
          <>
            <title>{query ? `نتایج جستجو برای "${query}" - نوآوران پژوه` : "جستجو - نوآوران پژوه"}</title>
            <meta name="description" content={results.length > 0 ?
              `مشاهده ${results.length} نتیجه برای جستجوی "${query}" در دسته‌بندی‌های مواد شیمیایی، تجهیزات آزمایشگاهی و محصولات مصرفی پلاستیکی.`
              :
              `نتیجه‌ای برای جستجوی "${query}" یافت نشد. جستجوی خود را تغییر دهید یا از دسته‌بندی‌های سایت استفاده کنید.`} />
          </>
        }
      </Helmet>

      <Header />
      <main className='mainContainer container-lg'>
        <div className='d-flex gap-4'>
          <PageTitle title={`نتایج جستجو برای '${query}' :`} style={{ marginBottom: '0' }} />
          <h2 className={styles.resultsCount}>{results.length ? `${results.length} نتیجه` : ''}</h2>
        </div>
        <div className="container mt-4">
          {isLoading ? <Loading />
            :
            results.length > 0 ?
              <ul className={styles.results_container} dir="ltr">
                {results.map(result =>
                  <li key={result.id}>
                    <Link className={styles.card_container} to={`/inventory/${result.brand_slug}`}>
                      <img className={styles.image} src={result.image ? result.image : "/assets/images/noImage.jpg"} alt={result.name} loading='lazy' />
                      <p className='text-truncate w-100 px-2' title={result.name}>{result.name}</p>
                      <p className='text-truncate w-100 px-2' title={result.brand}>{result.brand} {result.volume && `(${result.volume})`}</p>
                      <p className='text-truncate w-100 px-2' title={result.UPC}>Cat: {result.cat}</p>
                      <p className='text-truncate w-100 px-2' title={result.UPC}>Cas: {result.cas}</p>
                    </Link>
                  </li>
                )}
              </ul>
              :
              <Alert variant="danger">
                <p>متاسفانه نتیجه‌ ای برای " <span className='fw-bold'>{query}</span> " یافت نشد!</p> جستجوی خود را با زبان دیگری (انگلیسی یا فارسی) انجام دهید یا از دسته‌ بندی‌ های سایت استفاده کنید.
              </Alert>
          }
        </div>
      </main>
      <Footer />
    </>
  );
}
